import { GetterTree } from "vuex";
import { LicenseState } from "./types";
import { RootState } from "../types";

export const getters: GetterTree<LicenseState, RootState> = {
	getLicenseCameraLimit: state => state.licenseDetails.maxCameras,
	getLicenseGuardLimit: state => state.licenseDetails.maxGuards,
	getLicenseOperatorLimit: state => state.licenseDetails.maxOperators,
	getLicenseUserLimitDefinitions: state => state.userLimitDefinitions
};
